<nav class="layout-breadcrumb">
    <ol>
        <li [routerLink]="[pathHome]" class="cursor-pointer"><i class="pi pi-home"></i></li>
        <ng-template ngFor let-item let-last="last" [ngForOf]="breadcrumbs$ | async">
            <li><i class="pi pi-angle-right"></i></li>
            <li>
                <span>{{ item.label }}</span>
            </li>
        </ng-template>
    </ol>
</nav>
<div class="layout-breadcrumb-buttons">
    <button pButton pRipple type="button" [icon]="favoriteIcon" class="p-button-rounded p-button-text p-button-plain"
        (click)="favoriteOnAction()"></button>
        
    <button pButton pRipple type="button" icon="pi pi-question-circle" class="p-button-rounded p-button-text p-button-plain"
        (click)="helpOnAction()"></button>
</div>